import React from 'react'
import { ChecklistItemWithResourceInfo } from 'TypeDefs/Goal'
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
} from '@resiliatech/birdsong'
import { Goal } from 'Generated/graphql-types'
import { TaskItemV2 } from '../TaskItemV2/TaskItemV2'
import {
  HeaderDueDateContainer,
  HeaderTaskActionsContainer,
  HeaderTaskContentContainer,
  TableRow,
} from './TaskListV2.styled'
import { UpsertTaskHandler } from '../types'

type TaskListV2Props = {
  goal: Goal
  isResourceLoading: boolean
  onDuplicateTask: (task: ChecklistItemWithResourceInfo) => void
  onEditTask: (task: ChecklistItemWithResourceInfo) => void
  onUpsertTask: UpsertTaskHandler
  tasks: ChecklistItemWithResourceInfo[]
}

export const TaskListV2 = ({
  goal,
  tasks,
  isResourceLoading,
  onDuplicateTask,
  onEditTask,
  onUpsertTask,
}: TaskListV2Props) => (
  <Paper variant='outlined' elevation={0}>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow isHeader>
            <HeaderTaskContentContainer>Task</HeaderTaskContentContainer>
            <HeaderDueDateContainer>Due Date</HeaderDueDateContainer>
            <HeaderTaskActionsContainer>Actions</HeaderTaskActionsContainer>
          </TableRow>
        </TableHead>
        <TableBody>
          {tasks.map((task) => (
            <TaskItemV2
              key={task.id}
              goal={goal}
              isResourceLoading={isResourceLoading}
              onDuplicateTask={onDuplicateTask}
              onEditTask={onEditTask}
              onUpsertTask={onUpsertTask}
              task={task}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
)
